import watchNewFilterCalendario from './saga/newFilter';

export const calendarioSaga = [
    watchNewFilterCalendario(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
